import api from '@/services/onlineInquiryApi.js';

const appError = {
  applicationError: {
    hasError: true,
    error: [" We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."]
  }
};

const healthCheckError = {
  serviceError: {
    hasError: true,
    error: [
      "This service is temporarily unavailable. Please try again shortly."
    ]
  }
};

export default {
  async healthCheck({ commit }) {
    try {
      const res = await api.healthCheck();
      void res;
    } catch (err) {
      if (err?.response?.status === 503) {
        commit('setErrors', {
          maintenanceError: {
            hasError: true,
            error: [err.response?.data?.response?.message || '']
          }
        });
      }
      else {
        commit("setErrors", healthCheckError);
      }
    }
  },


  async fetchDepartments({ commit }) {
    try {
      const res = await api.fetchDepartments();
      if (res?.data) {
        const mapped = res.data.map(d => ({
          label: d.name,
          value: d.id,
          acceptSupportingDocument: d.acceptSupportingDocument
        }));
        commit('setDepartments', mapped);
      }
    } catch (err) {
      commit("setErrors", appError);
    }
  },

  async submitForm({ commit }, formData) {
    commit('setLoading', true);
    try {
      const res = await api.submit(formData);
      const payload = res?.data;

      if (res?.status === 200) {
        return payload;
      }
      commit("setErrors", appError);
      return null;
    } catch (err) {
      if (err?.response?.status === 503) {
        commit('setErrors', {
          maintenanceError: {
            hasError: true,
            error: [err.response?.data?.response?.message || '']
          }
        });
      }
      else if (err?.response?.status === 400) {
        const formattedErrors = [];
        Object.values(err.response?.data?.errors || {}).forEach(error => {
          if (Array.isArray(error)) {
            formattedErrors.push(...error);
          } else {
            formattedErrors.push(error);
          }
        });
        commit('setErrors', {
          applicationError: {
            hasError: true,
            error: formattedErrors
          }
        });
      }
      else {
        commit("setErrors", appError);
      }
      return null;
    } finally {
      commit('setLoading', false);
    }
  }
};